import { Enhance, withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelResults } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_results.css';

export interface ILevelTypeResultsProps extends Omit<ILevelResults,
    | 'type'> {
    type?: 'results';
    imageHeight?: number;
}

export const LevelTypeResults: React.FC<ILevelTypeResultsProps
    & { BaseLevel: React.FC<ILevelProps> }>
    = props => {
        const {
            title: resultsTitle,
            results,
            name,
            tag,
            imageHeight,
            BaseLevel,
            ...otherProps } = props;

        const resultsMod = { size: results.length };

        const height = imageHeight && imageHeight > 0 ? imageHeight : undefined;

        return (
            <BaseLevel {...otherProps}>
                <>
                    <div className={cnLevel('head')}>
                        {name && <div className={cnLevel('name')}>{name}</div>}
                        {tag && <div className={cnLevel('tag')}>{tag}</div>}
                    </div>
                    <HtmlContent
                        className={cnLevel('title')}
                        content={resultsTitle}
                        />
                    <div className={cnLevel('results', resultsMod)}>{
                        results.map(({ title, imageSrc, description }) => (
                            <div key={title} className={cnLevel('result')}>
                                <div className={cnLevel('result-image')}>
                                    <img src={imageSrc} alt={title} height={height} />
                                </div>
                                <HtmlContent
                                    className={cnLevel('result-title')}
                                    content={title}
                                    />
                                <HtmlContent
                                    className={cnLevel('result-description')}
                                    content={description}
                                    />
                            </div>
                        ))}
                    </div>
                </>
            </BaseLevel>
        );
    };

export const withLevelTypeResults = (enhance: Enhance<ILevelTypeResultsProps & ILevelProps>) =>
    withBemMod<ILevelTypeResultsProps, ILevelProps>(
        cnLevel(),
        { type: 'results' },
        enhance
    );
